import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import CheckboxSimpleDropdown from "./filter/desktop/CheckboxSimpleDropdown";
// import CheckboxLabelDropdown from "./filter/desktop/CheckboxLabelDropdown";
import { useApp } from "../../../contexts";
import { FilterIcon } from "../../../components/Icons/FilterIcon";
import { TabSubOption } from "./TabSubscriptionByType";

function FilterDropdown(props) {
  const { filterData, setFilterData, tabType } = props;
  const { T } = useApp();

  const [show, $show] = useState(false);
  const [options, $options] = useState([]);
  // const [statuss, $statuss] = useState([]);
  const optionList = useMemo(() => {
    if (tabType === TabSubOption.base) {
      return [
        { value: "SUB_PRE_SOT", title: "Essential" },
        { value: "SUB_PRE", title: "Premium" },
        { value: "SUB_UN", title: "Unlimited" },
      ];
    }
    if (tabType === TabSubOption.plus) {
      return [
        { value: "AVATAR_SUB_01", title: "ART PLUS LV 0.1" },
        { value: "AVATAR_SUB_10", title: "ART PLUS LV 1" },
        { value: "AVATAR_SUB_20", title: "ART PLUS LV 2" },
        { value: "AVATAR_SUB_30", title: "ART PLUS LV 3" },
        { value: "AVATAR_SUB_40", title: "ART PLUS LV 4" },
        { value: "AVATAR_SUB_50", title: "ART PLUS LV 5" },
      ];
    }
    if (tabType === TabSubOption.ai) {
      return [
        { value: "starter", title: "STARTER" },
        { value: "special", title: "SPECIAL" },
      ];
    }
    return []
  }, [tabType]);

  // const [statusOptions, $statusOptions] = useState([
  //   { value: "", title: "All" },
  //   { value: "1", title: "Active" },
  //   { value: "4", title: "Canceled" },
  // ]);
  const handleDropdown = () => {
    $show(!show);
  };
  const onChangeOption = (val) => {
    const data = val.map((v) => v);
    $options(data);
    setFilterData({
      options: data,
    });
  };
  // const onChangeStatus = (val) => {
  //   $statuss(val);
  //   setFilterData({
  //     statuss: val,
  //   });
  // };
  useEffect(() => {
    // $statuss(filterData.statuss || []);
    $options(filterData.options || []);
  },[])

  return (
    <div className="relative">
      <div className="w-[40px] lg:w-[125px]">
        <div
          className={
            "flex justify-between items-center py-[6px] px-2 lg:px-5 h-[42px] w-full border border-suzu-gray-3 border-solid bg-white rounded-[10px]" +
            (show ? " relative z-20" : "")
          }
          onClick={handleDropdown}
        >
          <span>
            <FilterIcon />
          </span>
          <span className={`text-sm text-black hidden lg:block`}>{T("Filter")}</span>
        </div>
      </div>

      {show && (
        <div className="absolute w-[250px] px-[12px] left-unset right-0 lg:left-0 top-[100%] z-10 rounded-[15px] shadow-lg bg-white pt-2 pb-3">
          <div className="">
            <CheckboxSimpleDropdown
              title={T("Option")}
              name={"options"}
              options={optionList}
              value={options}
              t={T}
              onChange={(val) => onChangeOption(val)}
            />
          </div>
        </div>
      )}
    </div>
  );
}

FilterDropdown.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func,
};

export default FilterDropdown;
